import styled from "styled-components";

export const StyledInput = styled.input`
    font-family: inherit;
    font-weight: inherit;

    text-align: center;

    width: 100%;
    height: 100%;
`;

export const StyledIconContainer = styled.div<{ hasValue?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    width: 2.2rem;
    height: 2.2rem;

    border-radius: 0.2rem;

    &:hover {
        border: solid 2px
            ${(props) =>
                props.hasValue
                    ? props.theme.colors.success[300]
                    : props.theme.colors.neutral[300]};
        background: ${(props) => props.theme.colors.neutral[100]};
    }

    background: ${(props) =>
        props.hasValue ? props.theme.colors.success[100] : "initial"};

    & > * {
        fill: ${(props) =>
            props.hasValue ? props.theme.colors.success[700] : "initial"};
    }
`;
